import * as React from 'react';
import type { SVGProps } from 'react';
const ArrowDown = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={18}
        height={10}
        {...props}
    >
        <defs>
            <path
                id="prefix__a"
                d="M1.88 14 .5 12.603 9 4l8.5 8.603L16.12 14 9 6.795z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="matrix(1 0 0 -1 0 14)">
            <mask id="prefix__b" fill="#fff">
                <use xlinkHref="#prefix__a" />
            </mask>
            <use xlinkHref="#prefix__a" fill="#767676" fillRule="nonzero" />
            <g fill="#767676" mask="url(#prefix__b)">
                <path d="M8.877 0h.246c1.912 0 3.48.371 4.784 1.069a7.27 7.27 0 0 1 3.024 3.024C17.63 5.396 18 6.965 18 8.877v.246c0 1.912-.371 3.48-1.069 4.784a7.27 7.27 0 0 1-3.024 3.024C12.604 17.63 11.035 18 9.123 18h-.246c-1.912 0-3.48-.371-4.784-1.069a7.27 7.27 0 0 1-3.024-3.024C.37 12.604 0 11.035 0 9.123v-.246c0-1.912.371-3.48 1.069-4.784a7.27 7.27 0 0 1 3.024-3.024C5.396.37 6.965 0 8.877 0" />
            </g>
        </g>
    </svg>
);
export default ArrowDown;
